(function(angular) {
    'use strict';

    angular.module('aprima-core').config([
        '$provide',
        QAllSettled,
    ]);

    function QAllSettled($provide) {
        // https://stackoverflow.com/questions/18888104/angularjs-q-wait-for-all-even-when-1-rejected
        $provide.decorator('$q', [
            '$delegate',
            addAllSettled,
        ]);

        function addAllSettled($delegate) {
            var $q = $delegate;

            $q.allSettled = $q.allSettled || allSettled;

            return $q;

            function allSettled(promises) {
                // Implementation of allSettled function from Kris Kowal's Q:
                // https://github.com/kriskowal/q/wiki/API-Reference#promiseallsettled

                var wrapped = angular.isArray(promises) ? [] : {};

                angular.forEach(promises, function(promise, key) {
                    if (!wrapped.hasOwnProperty(key)) {
                        wrapped[key] = wrap(promise);
                    }
                });

                return $q.all(wrapped);
            }

            function wrap(promise) {
                return $q.when(promise)
                    .then(function (value) {
                        return { state: 'fulfilled', value: value };
                    }, function (reason) {
                        return { state: 'rejected', reason: reason };
                    });
            }
        }
    }
})(window.angular);